export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"facebook-domain-verification","content":"xgu1tetzbvqoax6ac1ibbv9gq39ykn"},{"name":"google-site-verification","content":"-jW_7hTi2NBzPTHTtevqCXA6aMVyEiDgmAari3VNPSI"},{"name":"baidu-site-verification","content":"ldZLnVAkO3"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/intlPC/favicon.ico"}],"style":[],"script":[{"src":"https://js.40017.cn/fed/tianqiong/tqkit.1.3.7.js"},{"src":"/intlPC/js/defaultHeadFooterConfig.js?v=20260924"}],"noscript":[]}

export const appCdnURL = "https://file.reshg.com/hopegoo/web-pc/product"

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false